<template>
  <v-container fluid>
    <InvalidLink v-if="forms && forms.length == 0" />
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-fade-transition appear>
      <v-row v-if="!loading">
        <v-col
          v-for="(form, i) in forms"
          :key="i"
          cols="12"
          lg="6"
          class="pb-1"
        >
          <v-scale-transition appear mode="in-out" group hide-on-leave>
            <v-card :key="i">
              <v-card-text
                class="grey--text text--darken-3 mb-n2 font-weight-medium"
              >
                <div>{{ $t("label.previsitForm") }}</div>
                <span
                  :class="$vuetify.breakpoint.mdAndUp ? `headline` : `title`"
                >
                  {{ formDescription(form) }}
                </span>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn
                  text
                  :disabled="!!form.completed_on"
                  color="primary"
                  :to="
                    $i18nRoute({
                      name: 'DynamicForm',
                      params: {
                        form: form.form,
                        formId: form.id,
                        expiration: form.expires_on,
                      },
                    })
                  "
                >
                  {{
                    form.completed_on
                      ? $t("button.submitted")
                      : $t("button.completeForm")
                  }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-scale-transition>
        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>
import InvalidLink from "@/components/forms/InvalidLink";

export default {
  name: "Status",
  components: {
    InvalidLink,
  },
  i18n: {
    messages: {
      en: {
        forms: {
          PHQ: "Patient Health Questionnaire",
          DAST: "Drug Use Screen",
          AUDIT: "Alcohol Use Screen",
          SBIRT: "Substance Use Screen",
          CRAFFT: "Substance Screen",
          GAD: "Anxiety Screen",
          PRAPARE: "PRAPARE",
          SDOH: "Social Determinants of Health",
          PDG: "Patient Demographics",
        },
      },
      es: {
        forms: {
          PHQ: "Cuestionario Sobre La Salud",
          DAST: "Cuestionario De Uso De Drogas",
          AUDIT: "Cuestionario De Detección De Alcohol",
          SBIRT: "Cuestionario De Uso De Sustancias",
          CRAFFT: "Cuestionario De Uso De Sustancias",
          GAD: "Cuestionario De Ansiedad",
          PRAPARE: "PRAPARE",
          SDOH: "Determinantes Sociales de la Salud",
          PDG: "Demografía del paciente",
        },
      },
    },
  },
  data: () => ({
    forms: undefined,
    loading: false,
  }),
  computed: {},
  mounted() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    }
    this.getForms();
  },
  methods: {
    formDescription(form) {
      if (form.form.includes("PHQ")) return this.$i18n.t("forms.PHQ");
      else if (form.form.includes("GAD")) {
        return this.$i18n.t("forms.GAD");
      } else {
        return this.$i18n.t(`forms.${form.form}`);
      }
    },
    getForms() {
      this.loading = false;
      this.axios
        .get(`/forms/${this.id}`)
        .then((response) => {
          this.forms = response.data;
        })
        .catch((error) => {
          this.$router.push({
            name: "landing",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
